import React from "react";

const Helmet = ({title}) => {
  const movieName = (document.title = title);

  return 
};

export default Helmet;
